import { SET_PASAJEROS } from "../types";
import IPasajeros from "../../interfaces/IPasajeros";

export const setPasajeros = (payload: IPasajeros) => ({type: SET_PASAJEROS, payload});